/**
 * @generated SignedSource<<ffd7c77601212abbb4e1296caa4905a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type UpsertAWSAccountDiscoveryInput = {
  custodianRole?: string | null | undefined;
  description?: string | null | undefined;
  externalID?: string | null | undefined;
  memberRole?: string | null | undefined;
  name?: string | null | undefined;
  orgReadRole: string;
};
export type UpsertAWSAccountDiscoveryMutation$variables = {
  input: UpsertAWSAccountDiscoveryInput;
};
export type UpsertAWSAccountDiscoveryMutation$data = {
  readonly upsertAWSAccountDiscovery: {
    readonly accountDiscovery: {
      readonly config: {
        readonly custodianRole?: string;
        readonly externalID?: string | null | undefined;
        readonly memberRole?: string;
        readonly orgID?: string;
        readonly orgRole?: string;
      };
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly provider: CloudProvider;
      readonly schedule: {
        readonly suspended: boolean;
      };
      readonly validity: {
        readonly message: string;
        readonly success: boolean;
        readonly when: string;
      } | null | undefined;
    };
  } | null | undefined;
};
export type UpsertAWSAccountDiscoveryMutation = {
  response: UpsertAWSAccountDiscoveryMutation$data;
  variables: UpsertAWSAccountDiscoveryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "custodianRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberRole",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgRole",
      "storageKey": null
    }
  ],
  "type": "AWSAccountDiscoveryConfig",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountDiscoverySchedule",
  "kind": "LinkedField",
  "name": "schedule",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "suspended",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationInfo",
  "kind": "LinkedField",
  "name": "validity",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "when",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertAWSAccountDiscoveryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertAccountDiscoveryPayload",
        "kind": "LinkedField",
        "name": "upsertAWSAccountDiscovery",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDiscovery",
            "kind": "LinkedField",
            "name": "accountDiscovery",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpsertAWSAccountDiscoveryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertAccountDiscoveryPayload",
        "kind": "LinkedField",
        "name": "upsertAWSAccountDiscovery",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDiscovery",
            "kind": "LinkedField",
            "name": "accountDiscovery",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "config",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "32b15b90875919286d3a16d17d5b1941",
    "id": null,
    "metadata": {},
    "name": "UpsertAWSAccountDiscoveryMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertAWSAccountDiscoveryMutation(\n  $input: UpsertAWSAccountDiscoveryInput!\n) {\n  upsertAWSAccountDiscovery(input: $input) {\n    accountDiscovery {\n      config {\n        __typename\n        ... on AWSAccountDiscoveryConfig {\n          custodianRole\n          externalID\n          memberRole\n          orgID\n          orgRole\n        }\n      }\n      description\n      id\n      name\n      provider\n      schedule {\n        suspended\n      }\n      validity {\n        message\n        success\n        when\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f56c546730929ed43e1b2bd1404a00d";

export default node;
